export default __webpack_public_path__ + "static/banner_it_staff-2d0fe9ea7937e850f39545d4986e8168.webp";